<template>
  <div class="orders-table-2">
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-btn @click.stop="drawer = !drawer" color="yellow ml-2">
          <v-icon left>mdi-chart-bar</v-icon>
          <span>STATS</span>
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :search="search"
        :items="computedOrders"
        :loading="isLoading"
        sort-by="placed_at"
        class="elevation-1"
      >
        // eslint-disable-next-line
        <template v-slot:item.kitchen="{ item }">
          <span>{{ item.kitchen }}</span>
        </template>
        // eslint-disable-next-line
        <template v-slot:item.concept="{ item }">
          <v-avatar size="50px" tile>
            <v-img :src="item.concept_logo" contain class />
          </v-avatar>
        </template>
        // eslint-disable-next-line
        <template v-slot:item.platform="{ item }">
          <v-avatar size="50px" tile>
            <v-img :src="item.platform_logo" contain class />
          </v-avatar>
        </template>
        // eslint-disable-next-line
        <template v-slot:item.status="{ item }">
          <v-chip :color="getStatusColor(item.status)" small dark>{{
            item.status
          }}</v-chip>
        </template>
        // eslint-disable-next-line
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="openDetails(item)"
            >mdi-dots-horizontal</v-icon
          >
        </template>
      </v-data-table>
    </v-card>
    <v-navigation-drawer v-model="drawer" fixed temporary :width="drawerWidth">
      <DataStats
        :orders="orders"
        :concepts="concepts"
        :kitchens="kitchens"
        :platforms="platforms"
        :countries="countries"
        v-on:close="drawer = false"
      />
    </v-navigation-drawer>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DataStats from "@/components/Orders/DataStats";

export default {
  components: { DataStats },
  props: {
    orders: { type: Array },
    isLoading: { type: Boolean },
    concepts: { type: Array },
    kitchens: { type: Array },
    platforms: { type: Array },
    countries: { type: Array },
  },
  data: function () {
    return {
      headers: [
        {
          text: "Date",
          align: "start",
          sortable: true,
          value: "placed_at",
        },
        { text: "Number", value: "number", align: "center" },
        { text: "Kitchen", value: "kitchen", align: "center" },
        { text: "Concept", value: "concept", align: "center" },
        { text: "Platform", value: "platform", align: "center" },
        { text: "Status", value: "status", align: "center" },
        { text: "Price (€)", value: "price_in_euros", align: "center" },
        { text: "Actions", value: "actions", align: "center", sortable: false },
      ],
      search: "",
      drawer: false,
    };
  },
  computed: {
    computedOrders() {
      let res = [];
      this.orders.forEach((order) => {
        let kitchen = this.getElementByUuid(order.kitchen_uuid, this.kitchens);
        let concept = this.getElementByUuid(order.concept_uuid, this.concepts);
        let platform = this.getElementByUuid(
          order.platform_uuid,
          this.platforms
        );
        res.push({
          uuid: order.uuid,
          placed_at: this.getFormattedDate(order),
          number: order.number,
          kitchen: kitchen ? kitchen.id : order.kitchen,
          kitchen_uuid: kitchen ? kitchen.uuid : order.kitchen_uuid,
          platform: platform ? platform.label : order.platform,
          platform_logo: platform ? platform.logo : order.platform,
          platform_uuid: platform ? platform.uuid : order.platform_uuid,
          concept: concept ? concept.label : order.concept,
          concept_logo: concept ? concept.logo : order.concept,
          concept_uuid: concept ? concept.uuid : order.concept_uuid,
          status: order.status,
          timezone: order.timezone,
          price_in_euros: this.formatPrice(order.price_in_euros),
        });
      });
      return res;
    },
    drawerWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "100%";
        case "sm":
          return "100%";
        case "md":
          return "50%";
        case "lg":
          return "50%";
        case "xl":
          return "50%";
      }
      return "100%";
    },
  },
  methods: {
    getFormattedDate(item) {
      let date_utc = moment.utc(item.placed_at, "YYYY-MM-DDTHH:mm:ssZ");
      let date = date_utc.clone().tz(item.timezone);
      return date.format("YYYY-MM-DD HH:mm:ss");
    },
    getElementByUuid(uuid, list) {
      return list.find((obj) => obj.uuid === uuid);
    },
    getStatusColor(status) {
      let greenStatus = [
        "accepted",
        "created",
        "picked_up_by_customer",
        "in_transit",
        "placed",
        "ready_for_pickup",
        "delivered",
      ];
      let yellowStatus = ["remade_restaurant", "remade_platform"];
      let redStatus = ["rejected", "cancelled"];
      if (greenStatus.includes(status)) {
        return "green";
      } else if (yellowStatus.includes(status)) {
        return "yellow";
      } else if (redStatus.includes(status)) {
        return "red";
      } else {
        return "grey";
      }
    },
    addZero(number) {
      return number > 9 ? number : "0" + number;
    },
    formatPrice(price) {
      return Math.round((price + Number.EPSILON) * 100) / 100;
    },
    openDetails(item) {
      this.$emit("openDetails", item.uuid);
    },
  },
};
</script>
